import { compilePaletteVariant as n } from "./compilePaletteVariant.mjs";
const u = (t, e) => {
  switch (t) {
    case "stennHub":
      return r(e);
    default:
      return a(e);
  }
}, a = (t) => n("default", t), r = (t) => n("stennHub", t);
export {
  a as compileDefaultPaletteVariant,
  u as compilePalette,
  r as compileStennHubPaletteVariant
};
//# sourceMappingURL=compilePalette.mjs.map
